import React from 'react';
import { useAppSelector } from '~/hooks';
import config from '~/config';
import { dealerSelector } from '~/state/selectors';
import CopyTradingAgreementOld from '../CopyTradingAgreementOld';
import CopyTradingAgreementNew from '../CopyTradingAgreementNew';

type Props = {
    setAgreement: Function;
    setActiveRightTab?: Function;
};

function isNewAgreementWebsite(): boolean {
    return (
        config.WEBSITE === 'SANDSTONEFX' ||
        config.WEBSITE === 'PIPS24' ||
        config.WEBSITE === '4EXCLUB' ||
        config.WEBSITE === '24YIELD' ||
        config.WEBSITE === 'INVESTINGFF'
    );
}

function isNewAgreementDealer(dealer: string | undefined): boolean {
    return dealer === 'MERIDIAN' || dealer === 'MERIDIAN2';
}

function isNewAgreement(dealer: string | undefined): boolean {
    return isNewAgreementWebsite() && isNewAgreementDealer(dealer);
}

export default function CopyTradingAgreement({ setAgreement, setActiveRightTab }: Props) {
    const dealer = useAppSelector(dealerSelector);
    return isNewAgreement(dealer) ? (
        <CopyTradingAgreementNew setAgreement={setAgreement} setActiveRightTab={setActiveRightTab} />
    ) : (
        <CopyTradingAgreementOld setAgreement={setAgreement} setActiveRightTab={setActiveRightTab} />
    );
}
